import type { ValueOf } from '../util/typeUtils';

export const USER_RESOLVERS = {
    areAdvisersInTeam: 'areAdvisersInTeam',
    areUsersInCorporation: 'areUsersInCorporation',
    areUsersInDivision: 'areUsersInDivision',
    get: 'get',
    getAclPermissions: 'getAclPermissions',
    getAdvisersByBucket: 'getAdvisersByBucket',
    getAdvisersByBuckets: 'getAdvisersByBuckets',
    getAdvisersByCorporation: 'getAdvisersByCorporation',
    getAdvisersByDivision: 'getAdvisersByDivision',
    getAdvisersByRole: 'getAdvisersByRole',
    getAdvisersByTeam: 'getAdvisersByTeam',
    getAdvisersToBeRepresented: 'getAdvisersToBeRepresented',
    getAdvisersWithoutTeam: 'getAdvisersWithoutTeam',
    getAssignableUsers: 'getAssignableUsers',
    getAssignedAdvisorForOwner: 'getAssignedAdvisorForOwner',
    getBuckets: 'getBuckets',
    getDelegateId: 'getDelegateId',
    getDivisionsByUserId: 'getDivisionsByUserId',
    getGroupAssignment: 'getGroupAssignment',
    getLeadTrackStatus: 'getLeadTrackStatus',
    getOwnedBuckets: 'getOwnedBuckets',
    getPossibleDelegates: 'getPossibleDelegates',
    getRegistrationStep: 'getRegistrationStep',
    getRepresentedUsers: 'getRepresentedUsers',
    getRole: 'getRole',
    getSchufaAccess: 'getSchufaAccess',
    getSecret: 'getSecret',
    getTeamsByCorporation: 'getTeamsByCorporation',
    getUserNameById: 'getUserNameById',
    getUserNames: 'getUserNames',
    getUsers: 'getUsers',
    isDeactivated: 'isDeactivated',
    isInCorporation: 'isInCorporation',
    isInDivision: 'isInDivision',
    isInTeam: 'isInTeam',
    isLocked: 'isLocked',
    list: 'list',
    listActivated: 'listActivated',
} as const;

export type USER_RESOLVER = ValueOf<typeof USER_RESOLVERS>;
